export default {
  call: '전화',
  text: '문자',
}
